import { apiConstants } from '../../apiConstant'
import {  formDataCommonFunctionUnAuth } from '../../serviceCall'

export const verifySecurityCodeApi = (data, callback, errorCallBack) => {
   
  return async (dispatch) => {
    
    formDataCommonFunctionUnAuth(data,apiConstants.AUTH.VERIFY_SECURITY_CODE)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
